import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Typography, Box } from "@mui/material";
import { DB_READY } from "../../actions/constants";
import * as api from "../../api/index";
import { useTranslation } from "react-i18next";
const POLL_INTERVAL_MS = 2000;
const InitializingScreen = () => {
  const {
    t
  } = useTranslation("operations");
  const dispatch = useDispatch();
  const intervalRef = useRef(null);
  const resolvedCompany = useSelector(state => state.auth.resolvedCompany);
  const companyName = resolvedCompany?.companyName || resolvedCompany?.businessName || t("your workspace");
  useEffect(() => {
    const checkStatus = async () => {
      try {
        const {
          data
        } = await api.getDbInitStatus();
        if (data?.status === "ready") {
          clearInterval(intervalRef.current);
          dispatch({
            type: DB_READY
          });
        }
      } catch (_) {

        // Network error — keep polling
      }
    };
    checkStatus();
    intervalRef.current = setInterval(checkStatus, POLL_INTERVAL_MS);
    return () => clearInterval(intervalRef.current);
  }, [dispatch]);
  return <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={3}>
      
      <CircularProgress size={60} />
      <Typography variant="h5" fontWeight={600}>
        {t("Setting up {{companyName}}", { companyName })}
      </Typography>
      <Typography variant="body1" color="text.secondary">{t("We are initializing your workspace, please wait...")}

      </Typography>
    </Box>;
};
export default InitializingScreen;
